import { render, staticRenderFns } from "./TableRowNumVialsMixedPerTech.vue?vue&type=template&id=2266e8d5&lang=pug&"
import script from "./TableRowNumVialsMixedPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumVialsMixedPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2266e8d5')) {
      api.createRecord('2266e8d5', component.options)
    } else {
      api.reload('2266e8d5', component.options)
    }
    module.hot.accept("./TableRowNumVialsMixedPerTech.vue?vue&type=template&id=2266e8d5&lang=pug&", function () {
      api.rerender('2266e8d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowNumVialsMixedPerTech.vue"
export default component.exports